var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-credit-card',{attrs:{"host-field-id":_vm.containerName,"title":'מספר תעודת זהות',"error-message":_vm.socialId.error,"focused":_vm.focused,"empty":_vm.socialId.isEmpty}})
}
var staticRenderFns = []

export { render, staticRenderFns }